import { Suspense } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function KVKKPage() {
  return (
    <Suspense fallback={<div>Yükleniyor...</div>}>
      <div className="min-h-screen bg-gradient-to-b from-white via-primary-light/10 to-white">
        <Navbar />
        
        {/* Hero Section */}
        <section className="pt-32 pb-16 px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h1 className="font-serif text-4xl md:text-5xl font-bold text-primary-dark mb-4">
              KVKK Aydınlatma Metni
            </h1>
            <p className="text-lg text-gray-600">
              Kişisel Verilerin Korunması Kanunu Kapsamında Bilgilendirme
            </p>
            <p className="text-base text-gray-500 mt-2">
              Son Güncelleme: {new Date().toLocaleDateString('tr-TR', { year: 'numeric', month: 'long', day: 'numeric' })}
            </p>
          </div>
        </section>

        {/* Content Section */}
        <section className="pb-20 px-6">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-lg p-8 md:p-12">
            
            <div className="space-y-8">
              {/* Section 1 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  1. Veri Sorumlusu
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  6698 sayılı Kişisel Verilerin Korunması Kanunu ("KVKK") uyarınca, kişisel verileriniz; veri sorumlusu olarak Deniz Erin tarafından aşağıda açıklanan kapsamda işlenebilecektir.
                </p>
                <div className="bg-primary-light/20 rounded-2xl p-6 space-y-2">
                  <p className="text-gray-700"><strong>Veri Sorumlusu:</strong> Deniz Erin</p>
                  <p className="text-gray-700"><strong>Adres:</strong> [Adres Bilgisi]</p>
                  <p className="text-gray-700"><strong>E-posta:</strong> info@denizerin.com</p>
                  <p className="text-gray-700"><strong>Telefon:</strong> +90 XXX XXX XX XX</p>
                </div>
              </div>

              {/* Section 2 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  2. İşlenen Kişisel Veriler
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Hizmetlerimizi sunabilmek amacıyla aşağıdaki kişisel verileriniz işlenmektedir:
                </p>
                <div className="space-y-4">
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-2">Kimlik Bilgileri</h3>
                    <p className="text-gray-700 text-sm">Ad, soyad, T.C. kimlik numarası (gerekli durumlarda), doğum tarihi, doğum yeri, doğum saati</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-2">İletişim Bilgileri</h3>
                    <p className="text-gray-700 text-sm">Telefon numarası, e-posta adresi, adres bilgileri</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-2">Müşteri İşlem Bilgileri</h3>
                    <p className="text-gray-700 text-sm">Randevu bilgileri, seans notları, hizmet geçmişi, talep ve şikayetler</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-2">Finansal Bilgiler</h3>
                    <p className="text-gray-700 text-sm">Fatura bilgileri, ödeme geçmişi (kredi kartı bilgileri işlenmez, güvenli ödeme sistemleri kullanılır)</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-2">İşlem Güvenliği Bilgileri</h3>
                    <p className="text-gray-700 text-sm">IP adresi, çerez kayıtları, tarayıcı bilgileri, cihaz bilgileri</p>
                  </div>
                  <div className="border-l-4 border-gold pl-4">
                    <h3 className="font-bold text-primary-dark mb-2">Özel Nitelikli Kişisel Veriler</h3>
                    <p className="text-gray-700 text-sm">Danışmanlık seanslarında paylaşılan kişisel yaşam bilgileri (açık rızanız ile işlenir)</p>
                  </div>
                </div>
              </div>

              {/* Section 3 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  3. Kişisel Verilerin İşlenme Amaçları
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Kişisel verileriniz aşağıdaki amaçlarla işlenmektedir:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Astrolojik danışmanlık, spiritüel danışmanlık ve şifa hizmetlerinin sunulması</li>
                  <li>Doğum haritası analizi ve kişisel raporların hazırlanması</li>
                  <li>Randevu oluşturma, yönetme ve hatırlatma bildirimleri gönderme</li>
                  <li>Müşteri ilişkileri yönetimi ve müşteri memnuniyetinin sağlanması</li>
                  <li>Ödeme işlemlerinin gerçekleştirilmesi ve fatura düzenlenmesi</li>
                  <li>İletişim faaliyetlerinin yürütülmesi</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Hizmet kalitesinin ölçülmesi ve iyileştirilmesi</li>
                  <li>Güvenlik ve erişim kontrollerinin sağlanması</li>
                  <li>İzniniz dahilinde pazarlama ve tanıtım faaliyetlerinin yürütülmesi</li>
                </ul>
              </div>

              {/* Section 4 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  4. Kişisel Verilerin Aktarılması
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Kişisel verileriniz, yukarıda belirtilen amaçların gerçekleştirilmesi doğrultusunda ve KVKK'nın öngördüğü şartlara uygun olarak:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Hizmet sağlayıcılarımıza (hosting, e-posta servisleri, ödeme sistemleri)</li>
                  <li>Yasal yükümlülüklerimiz gereği kamu kurum ve kuruluşlarına</li>
                  <li>Hukuki süreçlerin yürütülmesi için yetkili mercilere</li>
                  <li>İş ortaklarımıza (yalnızca gerekli ölçüde ve gizlilik sözleşmeleri ile)</li>
                </ul>
                <p className="text-gray-700 leading-relaxed mt-3">
                  aktarılabilmektedir. Yurt dışına veri aktarımı yapılması durumunda, KVKK'nın 9. maddesi uyarınca gerekli önlemler alınmaktadır.
                </p>
              </div>

              {/* Section 5 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  5. Kişisel Verilerin Toplanma Yöntemi ve Hukuki Sebepleri
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Kişisel verileriniz, web sitemiz, e-posta, telefon, sosyal medya kanalları ve yüz yüze görüşmeler aracılığıyla toplanmaktadır. Verileriniz aşağıdaki hukuki sebeplere dayanılarak işlenmektedir:
                </p>
                <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4">
                  <li>Açık rızanızın bulunması</li>
                  <li>Sözleşmenin kurulması veya ifası için gerekli olması</li>
                  <li>Yasal yükümlülüklerin yerine getirilmesi</li>
                  <li>Meşru menfaatlerimiz için veri işlemenin zorunlu olması</li>
                  <li>Temel hak ve özgürlüklerinize zarar vermemek kaydıyla, meşru menfaatlerimiz için gerekli olması</li>
                </ul>
              </div>

              {/* Section 6 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  6. Kişisel Veri Sahibinin Hakları
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  KVKK'nın 11. maddesi uyarınca, kişisel veri sahibi olarak aşağıdaki haklara sahipsiniz:
                </p>
                <div className="bg-gold/10 rounded-2xl p-6 space-y-3">
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Kişisel verilerinizin işlenip işlenmediğini öğrenme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Kişisel verileriniz işlenmişse buna ilişkin bilgi talep etme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Kişisel verilerinizin işlenme amacını ve bunların amacına uygun kullanılıp kullanılmadığını öğrenme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Yurt içinde veya yurt dışında kişisel verilerinizin aktarıldığı üçüncü kişileri bilme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Kişisel verilerinizin eksik veya yanlış işlenmiş olması halinde bunların düzeltilmesini isteme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">KVKK'nın 7. maddesinde öngörülen şartlar çerçevesinde kişisel verilerinizin silinmesini veya yok edilmesini isteme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Düzeltme, silme veya yok edilme taleplerinin kişisel verilerin aktarıldığı üçüncü kişilere bildirilmesini isteme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">İşlenen verilerin münhasıran otomatik sistemler vasıtasıyla analiz edilmesi suretiyle aleyhinize bir sonucun ortaya çıkmasına itiraz etme</p>
                  </div>
                  <div className="flex items-start space-x-3">
                    <i className="ri-checkbox-circle-fill text-gold text-xl mt-1"></i>
                    <p className="text-gray-700">Kişisel verilerinizin kanuna aykırı olarak işlenmesi sebebiyle zarara uğramanız halinde zararın giderilmesini talep etme</p>
                  </div>
                </div>
              </div>

              {/* Section 7 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  7. Başvuru Yöntemi
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  Yukarıda belirtilen haklarınızı kullanmak için başvurunuzu aşağıdaki yöntemlerle iletebilirsiniz:
                </p>
                <div className="bg-primary-light/20 rounded-2xl p-6 space-y-3">
                  <p className="text-gray-700"><strong>Yazılı Başvuru:</strong> [Adres Bilgisi]</p>
                  <p className="text-gray-700"><strong>E-posta:</strong> info@denizerin.com (Güvenli elektronik imza, mobil imza veya başvuru sahibine ait e-posta adresinden)</p>
                  <p className="text-gray-700"><strong>Kayıtlı Elektronik Posta (KEP):</strong> [KEP Adresi]</p>
                </div>
                <p className="text-gray-700 leading-relaxed mt-4">
                  Başvurularınız, talebin niteliğine göre en geç 30 (otuz) gün içinde ücretsiz olarak sonuçlandırılacaktır. İşlemin ayrıca bir maliyeti gerektirmesi halinde, Kişisel Verileri Koruma Kurulu tarafından belirlenen tarifedeki ücret alınabilir.
                </p>
              </div>

              {/* Section 8 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  8. Veri Güvenliği
                </h2>
                <p className="text-gray-700 leading-relaxed">
                  Kişisel verilerinizin güvenliğini sağlamak için KVKK'nın 12. maddesi uyarınca gerekli teknik ve idari tedbirleri almaktayız. Verilerinizin hukuka aykırı olarak işlenmesini ve erişilmesini önlemek, muhafazasını sağlamak amacıyla uygun güvenlik düzeyini temin etmeye yönelik tüm teknik ve idari tedbirler alınmıştır.
                </p>
              </div>

              {/* Section 9 */}
              <div>
                <h2 className="font-serif text-2xl font-bold text-primary-dark mb-4 flex items-center">
                  <span className="w-2 h-8 bg-gold rounded-full mr-3"></span>
                  9. İletişim
                </h2>
                <p className="text-gray-700 leading-relaxed mb-3">
                  KVKK kapsamındaki haklarınız ve kişisel verilerinizin işlenmesi hakkında detaylı bilgi almak için bizimle iletişime geçebilirsiniz:
                </p>
                <div className="bg-primary-light/20 rounded-2xl p-6 space-y-2">
                  <p className="text-gray-700"><strong>E-posta:</strong> info@denizerin.com</p>
                  <p className="text-gray-700"><strong>Telefon:</strong> +90 XXX XXX XX XX</p>
                  <p className="text-gray-700"><strong>Adres:</strong> [Adres Bilgisi]</p>
                </div>
              </div>

              {/* Important Notice */}
              <div className="bg-gold/10 border-l-4 border-gold rounded-lg p-6 mt-8">
                <p className="text-sm text-gray-700 leading-relaxed">
                  <strong className="text-primary-dark">Önemli Uyarı:</strong> Bu aydınlatma metni, 6698 sayılı Kişisel Verilerin Korunması Kanunu uyarınca hazırlanmıştır. Kişisel verilerinizin işlenmesine ilişkin detaylı bilgi için Gizlilik Politikamızı inceleyebilirsiniz.
                </p>
              </div>
            </div>
          </div>
        </section>

        <Footer />
      </div>
    </Suspense>
  );
}